import React, {useState} from "react"
import styled from "styled-components"
import {DateRangePicker} from "react-dates"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import moment from "moment"

import DropDown from "components/shared/DropDown"
import {reportsCustomOptions} from "./constants"
import {generateQuarterlyOptions, generateYearlyOptions} from "features/Reports/utils"

const DateRangeWrapper = styled.div`
	.DateInput {
		width: 80px;
		height: 28px;
	}
	.DateInput_input {
		font-size: 12px;
		font-weight: normal;
		width: 90%;
		padding: 5px;
		line-height: 10px;
	}
	.DateRangePickerInput_clearDates {
		padding: 5px;
		top: 45%;
		width: 25px;
	}
	.DateRangePickerInput_arrow {
		vertical-align: top;
		padding-right: 3px;
	}
	.CalendarDay__selected,
	.CalendarDay__selected_span,
	.CalendarDay__selected_span:hover {
	  background-color: rgb(125, 96, 255) !important;
	  border: 1px !important;
	}
	.CalendarDay__hovered_span,
	.CalendarDay__hovered_span:hover {
	  background-color: rgb(125, 96, 255) !important;
	  border: 1px solid #e4e7e7;
	  color: #fff;
	}
`

const PeriodDropdown = ({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	setReportsTableHeader,
	}) => {
	const [duration, setDuration] = useState("")
	const [focusedInput, setFocusedInput] = useState(null)

	const handleCustomDateChange = ({startDate, endDate}) => {
		const formattedStartDate = moment(startDate).format("DD MMMM YYYY");
		const formattedEndDate = moment(endDate).format("DD MMMM YYYY");
		setReportsTableHeader(`${formattedStartDate} - ${formattedEndDate}`)
		setStartDate(startDate)
		setEndDate(endDate)
	}

	const handleFocusChange = focusedInput => {
		setFocusedInput(focusedInput)
	}

	const handleDurationChange = data => {
		const selectedDuration = data.value
		setDuration(selectedDuration)

		// Reset start and end dates when duration changes
		setStartDate(null)
		setEndDate(null)
	}

	const convertTableHeader = (tableHeader) => {
		const [quarter, year] = tableHeader.split(' ');
		const quarterNumber = quarter.slice(1);
		const quarterText = `Quarter${quarterNumber}`;
		const formattedTableHeader = `${quarterText} - ${year}`;

		return formattedTableHeader;
	  }

	const handleDateChange = data => {
		const originalFormat = "DD/MM/YYYY"
		const desiredFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ"
		if(duration === "quarterly"){
			setReportsTableHeader(convertTableHeader(data.label))
		} else {
			setReportsTableHeader(data.label)
		}
		setStartDate(moment(data.value.startDate))
		setEndDate(moment(data.value.endDate))
	}

	const isOutsideRange = (date) => {
		if (focusedInput === "endDate") {
		  if (date.isSame(startDate, 'day')) {
			return false; // Allow selecting the same start and end date
		  }
		  return date.isBefore(startDate) || date.isAfter(moment().endOf("day"));
		} else if (focusedInput === "startDate") {
		  return date.isAfter(moment().endOf("day"));
		}
		return false;
	  };

	const renderCustomDropdown = () => {
		return (
			<div>
				<DateRangeWrapper>
					<DateRangePicker
						startDate={startDate}
						startDateId='start_date'
						endDate={endDate}
						endDateId='end_date'
						onDatesChange={handleCustomDateChange}
						focusedInput={focusedInput}
						onFocusChange={handleFocusChange}
						displayFormat='DD/MM/YYYY'
						hideKeyboardShortcutsPanel={true}
						minimumNights={0}
						showClearDates={true}
						showDefaultInputIcon={false} // Hide the default input icon
						inputIconPosition='after'
						customArrowIcon={<div>-</div>}
						anchorDirection='up'
						verticalSpacing={-400}
						numberOfMonths={1}
						isOutsideRange={isOutsideRange}
						maxDate={moment()}
						renderInput={({startDate, endDate, onFocus, ...rest}) => (
							<div>
								<input
									type='text'
									value={`${startDate?.format("DD/MM/YYYY")} - ${endDate?.format("DD/MM/YYYY")}`}
									readOnly
									onFocus={onFocus}
									{...rest}
								/>
								<button type='button' onClick={onFocus}>
									Calendar Icon
								</button>
							</div>
						)}
					/>
				</DateRangeWrapper>
			</div>
		)
	}

	const renderReportGenerator = () => {
		if (duration === "custom") {
			return renderCustomDropdown()
		} else if (duration === "quarterly") {
			return (
				<DropDown
					variant='primary'
					label='Select Quarter'
					items={generateQuarterlyOptions()}
					isLast
					onChange={handleDateChange}
				/>
			)
		} else if (duration === "yearly") {
			return (
				<DropDown
					variant='primary'
					label='Select Year'
					items={generateYearlyOptions()}
					isLast
					onChange={handleDateChange}
				/>
			)
		}
		return null
	}

	return (
		<div style={{ display: "flex", alignItems: "center" }}>
				<div style={{height: "40px", paddingRight: "20px", width: "200px"}}>
					<DropDown
					className='periodDropdown'
						name='countryCode'
						id='countryCode'
						testId='countryCode'
						variant='primary'
						label='Select Duration'
						items={reportsCustomOptions}
						onChange={handleDurationChange}
						style={{padding: "10px 22px 10px 12px"}}
					/>
				</div>

				<div style={{height: "40px", width: "200px"}}>{renderReportGenerator()}</div>
			</div>

	)
}

export default PeriodDropdown
